import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export interface UpdateRfqFileCaptionPayload {
  rfq_id: number;
  file_id: number;
  caption: string;
}

/**
 * Update the caption of a file in an RFQ.
 */
export const updateRfqFileCaption = async (
  payload: UpdateRfqFileCaptionPayload
): Promise<void> => {
  try {
    await apiService.patch(`/rfqs/${payload.rfq_id}/files/${payload.file_id}`, {
      caption: payload.caption ? payload.caption : null
    });
  } catch (error) {
    throw handleAxiosError(error);
  }
};
